import type { TaskCategory } from "@/domains/tasks/api/types";

export const TASK_CATEGORY_LABELS: Record<TaskCategory, string> = {
  placement: "Plaatsing",
  operations: "Operaties",
  external: "Externe partner",
  administration: "Administratie",
  decommission: "Ophaling",
};

export const TASK_CATEGORY_COLOR: Record<TaskCategory, string> = {
  placement: "bg-info-100 text-info-800 border-info-200",
  operations: "bg-primary-50 text-primary-800 border-primary-200",
  external: "bg-warning-100 text-warning-800 border-warning-200",
  administration: "bg-secondary-100 text-secondary-800 border-secondary-200",
  decommission: "bg-success-100 text-success-800 border-success-200",
};
